<template>
  <div class="index-page container">
    <n-card>
      <n-table :data="data" :columns="columns" :loading="$var('load')">
        <template #name="{item}">
          /{{ item.name }}
        </template>
        <template #isActive="{item}">
          {{ item.isActive ? 'Отображается' : 'Скрыта' }}
        </template>
        <template #tools="{item}">
          <n-button @click="change(item)">{{ item.isActive ? 'Скрыть' : 'Отобразить' }}</n-button>
        </template>
      </n-table>
    </n-card>
  </div>
</template>

<script>
export default {
  name: 'Index',
  data: () => ({
    data: [],
    columns: [
      { name: 'name', title: 'Путь', },
      { name: 'isActive', title: 'Статус', },
      { name: 'tools', title: '', },
    ],
  }),
  mounted() {
    this.loadModels()
  },
  methods: {
    loadModels() {
      this.$var('load', true)
      $api.app.pages.get().sort([ 'id,asc', ]).then((response) => {
        this.data = response.data.content
      }).finally(() => {
        this.$var('load', false)
      })
    },
    change(page) {
      $api.app.pages.edit(page.id, { isActive: !page.isActive, }).then(() => {
        this.loadModels()
      })
    },
  },
}
</script>

<style lang="scss" scoped>
  .index-page {
  
    --n-image-width: 550px;
    --n-image-height: 250px;
  }
</style>
